import { getCurrentScope as oe, onScopeDispose as re, watch as x, unref as r, ref as S, effectScope as ae, watchEffect as R, computed as y, nextTick as K, defineComponent as $, toRef as k, openBlock as A, createElementBlock as z, createElementVNode as W, normalizeClass as B, renderSlot as j, normalizeStyle as ie, provide as se, inject as ce, onMounted as ue } from "vue";
const q = Symbol(), Y = (t, e = 0, o = 1 / 0) => Math.max(e, Math.min(t, o));
function fe([t, e], [o, n]) {
  return {
    left: Math.min(t, o),
    top: Math.min(e, n),
    width: Math.abs(t - o),
    height: Math.abs(e - n)
  };
}
const M = () => {
};
function L(t) {
  return oe() ? (re(t), !0) : !1;
}
function E(t, e, o, n) {
  let l = M;
  const s = x(
    () => r(t),
    (a) => {
      l(), a && (a.addEventListener(e, o, n), l = () => {
        a.removeEventListener(e, o, n);
      });
    },
    { immediate: !0, flush: "sync" }
  );
  let c = () => {
    s(), l(), c = M;
  };
  const d = () => {
    c();
  };
  return L(d), d;
}
function de(t, e = {}) {
  const o = e.draggingElement ?? window, n = (p) => p.isPrimary ? e.pointerTypes ? e.pointerTypes.includes(p.pointerType) : !0 : !1, l = (p) => {
    r(e.preventDefault) && p.preventDefault();
  }, s = (p) => {
    var b;
    n(p) && (r(e.exact) && p.target !== r(t) || ((b = e.onStart) == null ? void 0 : b.call(e, p)) !== !1 && (a = p, u = E(o, "pointermove", c, !0), v = E(o, "pointerup", d, !0), m = E(o, "scroll", f, !0), l(p)));
  }, c = (p) => {
    var b;
    a = p, n(p) && ((b = e.onMove) == null || b.call(e, p), l(p));
  }, d = (p) => {
    var b;
    n(p) && ((b = e.onEnd) == null || b.call(e, p), u(), v(), m(), l(p));
  };
  let a;
  const f = () => {
    c(a);
  }, i = E(t, "pointerdown", s);
  let u = M, v = M, m = M, O = () => {
    i(), u(), v(), m(), O = M;
  };
  const g = () => {
    O();
  };
  return L(g), g;
}
function pe(t, e = {}) {
  const o = S(!1), n = S([0, 0]), l = S([0, 0]), s = ae(), c = R((d) => {
    r(e.disabled) || s.run(() => {
      const a = de(t, {
        ...e,
        preventDefault: !0,
        onStart(f) {
          var m;
          if (o.value)
            return !1;
          const i = r(t);
          if (!i)
            return !1;
          const u = i.getBoundingClientRect(), v = [
            f.clientX - u.left - i.clientLeft + i.scrollLeft,
            f.clientY - u.top - i.clientTop + i.scrollTop
          ];
          if (((m = e.onStart) == null ? void 0 : m.call(e, f, v)) === !1)
            return !1;
          n.value = v, l.value = v;
        },
        onMove(f) {
          var v;
          o.value = !0;
          const i = r(t);
          if (!i)
            return;
          const u = i.getBoundingClientRect();
          l.value = [
            f.clientX - u.left - i.clientLeft + i.scrollLeft,
            f.clientY - u.top - i.clientTop + i.scrollTop
          ], (v = e.onMove) == null || v.call(e, f);
        },
        onEnd(f) {
          var i;
          o.value = !1, n.value = [0, 0], l.value = [0, 0], (i = e.onEnd) == null || i.call(e, f);
        }
      });
      d(a);
    });
  });
  return { fromPoint: n, toPoint: l, isDragging: o, stop: c };
}
function ve(t, e) {
  const [o, [n, l]] = [r(t), r(e)];
  if (!o)
    return !1;
  const { clientLeft: s, scrollWidth: c, clientTop: d, scrollHeight: a } = o;
  return 0 <= n && s + c >= n && 0 <= l && d + a >= l;
}
function ge(t, e) {
  const [o, [n, l]] = [r(t), r(e)];
  if (!o)
    return [0, 0];
  const { scrollWidth: s, scrollHeight: c } = o;
  return [Y(s, 0, n), Y(c, 0, l)];
}
function me(t, e = {}) {
  const { fromPoint: o, toPoint: n, isDragging: l, stop: s } = pe(t, {
    ...e,
    onStart(a, f) {
      var i;
      if (!ve(t, f) || ((i = e.onStart) == null ? void 0 : i.call(e, a)) === !1)
        return !1;
    }
  }), c = y(() => {
    if (l.value)
      return fe(r(o), ge(t, n));
  }), d = y(() => {
    if (l.value && c.value) {
      const { left: a, top: f, width: i, height: u } = c.value;
      return {
        position: "absolute",
        boxSizing: "border-box",
        touchAction: "none",
        top: 0,
        left: 0,
        transform: `translate(${a}px, ${f}px)`,
        width: `${i}px`,
        height: `${u}px`
      };
    } else
      return {
        display: "none"
      };
  });
  return { fromPoint: o, toPoint: n, style: d, rect: c, isDragging: l, stop: s };
}
function ye(t) {
  const e = t.scrollWidth > t.clientWidth, o = t.scrollHeight > t.clientHeight, n = window.getComputedStyle(t), l = n.overflowX === "visible" || n.overflowX === "hidden", s = n.overflowY === "visible" || n.overflowY === "hidden";
  return e && !l || o && !s;
}
function I(t, e) {
  const { x: o = 0, y: n = 0 } = e;
  return (o === 0 || o < 0 && t.scrollLeft === 0 || o > 0 && t.scrollWidth - t.clientWidth - t.scrollLeft < 1) && (n === 0 || n < 0 && t.scrollTop === 0 || n > 0 && t.scrollHeight - t.clientHeight - t.scrollTop < 1);
}
function he(t, e = !0) {
  let o, n = !1;
  function l() {
    e && t(), o = requestAnimationFrame(() => {
      e || t(), n || l();
    });
  }
  return l(), () => {
    o && (cancelAnimationFrame(o), o = void 0, n = !0);
  };
}
function Se(t, e, o = {}) {
  const { maxScrollPadding: n = 30, minScrollVelocity: l = 2, maxScrollVelocity: s = 5, onEnd: c } = o, [d, a] = e, [f, i] = [
    Math.sign(d) * Math.max(
      l,
      Math.min(s, Math.abs(d) * (s / n))
    ),
    Math.sign(a) * Math.max(
      l,
      Math.min(s, Math.abs(a) * (s / n))
    )
  ];
  let u = M;
  return I(t, { x: f, y: i }) || (u = he(() => {
    t.scrollLeft += f, t.scrollTop += i, I(t, { x: f, y: i }) && (u(), c == null || c());
  })), u;
}
function Oe(t, e, o, n) {
  const { scrollGutter: l = 0 } = n || {};
  let s = M;
  const c = () => {
    s = R((d) => {
      const a = r(t), f = r(o);
      if (!a || !ye(a))
        return;
      const i = a.getBoundingClientRect(), u = {
        top: i.top + a.clientTop + l,
        bottom: i.top + a.clientTop + a.clientHeight - l,
        left: i.left + a.clientLeft + l,
        right: i.left + a.clientLeft + a.clientWidth - l
      }, [v, m] = f;
      let O = 0, g = 0;
      v < u.left ? O = v - u.left : v > u.right && (O = v - u.right), m < u.top ? g = m - u.top : m > u.bottom && (g = m - u.bottom), (O !== 0 || g !== 0) && d(Se(a, [O, g], n));
    });
  };
  return L(s), R((d) => {
    d(s), r(e) ? c() : s();
  });
}
function be(t, e) {
  return t.left <= e.left + e.width && e.left <= t.left + t.width && t.top <= e.top + e.height && e.top <= t.top + t.height;
}
function Ce({
  contentRef: t,
  containerRef: e,
  options: o,
  onChange: n,
  draggableOnOption: l,
  disabled: s,
  consumePointerDownedOnOption: c,
  onStart: d,
  onEnd: a
}) {
  const f = S([0, 0]), i = S(!1), {
    rect: u,
    style: v,
    isDragging: m,
    stop: O
  } = me(t, {
    disabled: s,
    onStart(g) {
      if (i.value = !1, !r(l) && c() || (d == null ? void 0 : d(g)) === !1)
        return !1;
      f.value = [g.clientX, g.clientY];
    },
    onMove(g) {
      i.value = !0, (g.clientX !== f.value[0] || g.clientY !== f.value[1]) && (f.value = [g.clientX, g.clientY]);
    },
    onEnd(g) {
      a == null || a(g);
    }
  });
  return Oe(e, m, f), x(u, () => {
    const g = /* @__PURE__ */ new Set();
    if (u.value) {
      for (const { dom: p, value: b, disabled: _ } of o)
        (_ || be(u.value, {
          left: p.offsetLeft,
          top: p.offsetTop,
          width: p.clientWidth,
          height: p.clientHeight
        })) && g.add(b);
      n(g);
    }
  }), { dragged: i, isDragging: m, areaStyle: v, stop: O };
}
function we({ onChange: t, isDisableClick: e, onStart: o, onEnd: n }) {
  return (s, c) => {
    if (e())
      return;
    const d = /* @__PURE__ */ new Set([s.value]);
    o(c), K(() => {
      t(d), n(c);
    });
  };
}
const De = (t, e) => {
  const o = /* @__PURE__ */ new Set();
  for (const n of t)
    e.has(n) || o.add(n);
  for (const n of e)
    t.has(n) || o.add(n);
  return o;
}, Me = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const o of t)
    if (!e.has(o))
      return !1;
  return !0;
}, ke = (t, { multiple: e, deselectRepeated: o }) => {
  const n = S(), l = () => {
    n.value = r(t);
  }, s = () => {
    n.value = void 0;
  }, c = y(() => r(n) || r(t));
  return { calcNewSelectedOptions: (a) => {
    if (r(e))
      return r(o) ? De(a, r(c)) : /* @__PURE__ */ new Set([...a, ...r(c)]);
    if (!Me(a, r(t)))
      return a;
  }, onStart: l, onEnd: s };
}, Ve = (t, e, o = {}) => {
  const n = y(() => o.valuePropName || "modelValue"), l = y(() => o.trigger || "update:modelValue"), s = y(() => o.defaultValuePropName || "defaultValue"), c = S(t.modelValue), d = y(() => Reflect.get(t, r(n)) !== void 0), a = y(() => Reflect.get(t, r(s)) !== void 0 ? t[r(s)] : o.defaultValue), f = y(() => r(d) ? t[r(n)] : r(c) !== void 0 ? r(c) : r(a));
  return x(
    d,
    () => {
      c.value = void 0;
    },
    { flush: "sync" }
  ), [f, (u, ...v) => {
    r(d) || (c.value = u), e(r(l), r(u), ...v);
  }];
}, Pe = {
  ctrl: "ctrlKey",
  shift: "shiftKey",
  meta: "metaKey",
  alt: "altKey"
}, Te = (t, e, { activeMultipleKeys: o }) => {
  const [n, l] = Ve(t, e, {
    valuePropName: "multiple",
    defaultValuePropName: "defaultMultiple",
    defaultValue: !1,
    trigger: "update:multiple"
  });
  return {
    multiple: n,
    onStart: (d) => {
      l(r(o).some((a) => !!d[Pe[a]]));
    },
    onEnd: () => {
      l(!1);
    }
  };
}, N = /* @__PURE__ */ $({
  __name: "DragSelect",
  props: {
    /**
     * binding value
     * @alias v-model
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
      default: void 0,
      validator(t) {
        const e = r(t);
        return e === void 0 || Array.isArray(e) || e instanceof Set;
      }
    },
    /**
     * whether DragSelect is disabled
     * @default false
     */
    disabled: {
      default: !1,
      validator(t) {
        return typeof r(t) == "boolean";
      }
    },
    draggableOnOption: {
      default: !0,
      validator(t) {
        return typeof r(t) == "boolean";
      }
    },
    clickOptionToSelect: {
      type: Boolean,
      default: !0
    },
    clickBlankToClear: {
      type: Boolean,
      default: !0
    },
    dragAreaClass: {
      type: String,
      default: ""
    },
    dragAreaStyle: {
      type: Object,
      default: () => ({})
    },
    background: {
      type: String,
      default: "rgba(66, 153, 225, 0.5)"
    },
    selectedOptionClass: {
      type: String,
      default: ""
    },
    selectedOptionStyle: {
      type: Object,
      default: () => ({})
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    defaultMultiple: {
      type: Boolean,
      default: void 0
    },
    activeMultipleKeys: {
      type: Array,
      default: () => ["ctrl", "meta", "shift"]
    },
    deselectRepeated: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "update:multiple", "change"],
  setup(t, { expose: e, emit: o }) {
    const l = t, s = o;
    function c(h) {
      const D = S(/* @__PURE__ */ new Set([]));
      return { selectedOptions: y(() => {
        const C = r(h) || D.value;
        return Array.isArray(C) ? new Set(C) : C;
      }), emitModelValue: (C) => {
        const T = Array.isArray(r(h)) ? Array.from(C) : C;
        D.value = T, s("update:modelValue", T), s("change", T);
      } };
    }
    function d(h, D) {
      const V = /* @__PURE__ */ new Set(), P = S(!1), C = S(!1);
      return se(q, {
        selectedOptionClass: k(l, "selectedOptionClass"),
        has(w) {
          return V.has(r(w));
        },
        isSelected(w) {
          return r(h).has(r(w).value);
        },
        add(w) {
          V.add(r(w));
        },
        delete(w) {
          V.delete(r(w));
        },
        onClick(w, ne) {
          D(r(w), ne), P.value = !0;
        },
        onPointerDown() {
          C.value = !0;
        }
      }), { options: V, consumeClickedOnOption: () => {
        try {
          return P.value;
        } finally {
          P.value = !1;
        }
      }, consumePointerDownedOnOption: () => {
        try {
          return C.value;
        } finally {
          C.value = !1;
        }
      } };
    }
    const { selectedOptions: a, emitModelValue: f } = c(
      k(l, "modelValue")
    ), { multiple: i, ...u } = Te(l, s, {
      activeMultipleKeys: k(l, "activeMultipleKeys")
    }), v = ke(a, {
      multiple: i,
      deselectRepeated: k(l, "deselectRepeated")
    }), m = (h) => {
      const D = v.calcNewSelectedOptions(h);
      D && f(D);
    }, O = () => !!Q.value, g = () => !r(l.clickOptionToSelect) || O(), p = () => !r(l.clickBlankToClear) || O(), b = we({
      onChange: m,
      isDisableClick: g,
      onStart: (h) => {
        u.onStart(h);
      },
      onEnd: () => {
        u.onEnd();
      }
    }), { options: _, consumeClickedOnOption: U, consumePointerDownedOnOption: G } = d(
      a,
      b
    ), X = S(), H = S(), {
      areaStyle: J,
      dragged: Q,
      isDragging: Z
    } = Ce({
      contentRef: X,
      containerRef: H,
      options: _,
      onChange: m,
      onStart: (h) => {
        v.onStart(), u.onStart(h);
      },
      onEnd: () => {
        v.onEnd(), u.onEnd();
      },
      consumePointerDownedOnOption: G,
      disabled: k(l, "disabled"),
      draggableOnOption: k(l, "draggableOnOption")
    }), ee = y(() => ({
      background: l.background,
      ...l.dragAreaStyle,
      ...J.value
    })), te = y(() => ({
      "drag-select": !0,
      "drag-select--disabled": l.disabled
    })), le = (h) => {
      U() || p() || (u.onStart(h), K(() => {
        m(/* @__PURE__ */ new Set()), u.onEnd();
      }));
    };
    return e({
      isDragging: Z
    }), (h, D) => (A(), z("div", {
      ref_key: "containerRef",
      ref: H,
      class: "drag-select__wrapper"
    }, [
      W("div", {
        ref_key: "contentRef",
        ref: X,
        class: B(te.value),
        style: { position: "relative" },
        onClick: le
      }, [
        j(h.$slots, "default"),
        W("div", {
          class: B(["drag-select__area", r(l).dragAreaClass]),
          style: ie(ee.value)
        }, null, 6)
      ], 2)
    ], 512));
  }
}), F = /* @__PURE__ */ $({
  __name: "DragSelectOption",
  props: {
    value: {
      required: !0,
      type: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    selectedClass: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, o = S(), n = y(() => ({
      dom: o.value,
      value: e.value,
      disabled: e.disabled
    })), l = ce(q), s = y(() => !!(l != null && l.isSelected(n.value))), c = y(() => ({
      "drag-select-option": !0,
      "drag-select-option--selected": s.value,
      "drag-select-option--disabled": e.disabled,
      ...l ? { [r(l.selectedOptionClass)]: s.value } : {},
      [e.selectedClass]: s.value
    })), d = (f) => {
      l == null || l.onClick(n.value, f);
    }, a = () => {
      l == null || l.onPointerDown();
    };
    return ue(() => {
      const f = x(
        () => e.disabled,
        (i) => {
          i ? l == null || l.delete(n) : l == null || l.add(n);
        },
        {
          immediate: !0
        }
      );
      return () => {
        f(), l == null || l.delete(n);
      };
    }), (f, i) => (A(), z("div", {
      ref_key: "dragSelectOptionRef",
      ref: o,
      class: B(c.value),
      onClick: d,
      onPointerdown: a
    }, [
      j(f.$slots, "default")
    ], 34));
  }
});
N.DragSelectOption = F;
N.install = Ee;
function Ee(t) {
  t.component("DragSelect", N), t.component("DragSelectOption", F);
}
export {
  N as DragSelect,
  F as DragSelectOption,
  N as default,
  Ee as install
};
